import React from 'react';
import api from "utils/api";
import { message } from 'antd';
import TherapyIntakeChart from './TherapyIntakeChart';
import TabComponent from 'Components/TabComponent';
import ListComponent from 'Components/ListComponent';
import Feedback from './Feedback';
import utils from 'utils';
import "./Others.scss";
import { CONSTANTS } from 'utils/constant';
import Loader from "Components/Loader";

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: false,
            v1_data:[],
            v2_data:[]
        };
    }

    getSummaryList() {
        this.setState({ isLoading: true });
        api
            .get_therapy_summary_list({ patient_id: this.props.data?.patient_id })
            .then(res => {
                let { status, data: { results } } = res.data || {};
                if (status == 200) {
                    (results || []).forEach(m => {
                        (m.assessment || []).forEach((n, i) => n["index"] = i + 1)
                    })
                    this.setState({
                        data: results, 
                   })
                
                   this.state.data.map((charts)=>{

                    if(charts.version=="v2"){this.setState({v2_data:[...this.state.v2_data,charts]})}
                    else if(charts.version=="v1"){this.setState({v1_data: [...this.state.v1_data,charts]})}
                            

                  })
                  this.setState({isLoading:false})

                }else{
                    message.error(res.data?.message, ErrorDuration);
                    this.setState({isLoading: false})
                }
            })
            .catch(err => { })
    }

    getConsultationTherapyList() {
        api.get_consultation_therapy_list({appointment_id: this.props.data})
        .then((res) => {
            let { status, data: { results } } = res.data || {};
                if (status == 200) {
                    (results || []).forEach(m => {
                        (m.assessment || []).forEach((n, i) => n["index"] = i + 1)
                    })
                    this.setState({
                        data: results
                    })
                }
        })
        .catch(()=>{

        })
    }

    renderAssesment(item) {

        return (
            <div className='assessment-item'>
                <div className='question-text'>{`${item.index}. ${item.question_text}`}</div>
                <div className='answer-container'>
                    {<ListComponent
                        renderType="client"
                        data={item.answers || []}
                        pagination={null}
                        render={(listItem) => {
                            return (
                                <div className='answers-list'><ul><li>{listItem}</li></ul></div>
                            )
                        }} />}
                </div>
            </div>
        )
    }

    componentDidMount() {
        if(!this.props.vc){
            this.getSummaryList()
        } else {
            this.getConsultationTherapyList()
        }
    }

    render() {
        return (
            <>
            {this.state.isLoading ? (
              <Loader />
            ) : (
            <div className={!this.props.vc ? "therapy-tab-wrapper-container" : "therapy-tab-wrapper-container-vc"}>
                 {!this.props.vc &&<div className='therapy-header'>
                    <div>Brief Psychotherapeutic Intake</div>
                </div>}
                <TabComponent tabPosition={this.props.vc ? "left" : "top"}
                    defaultActiveKey={"assessment"}
                    config={[
                        {
                            value: "assessment",
                            label: CONSTANTS.PERSONAL_GOALS,
                            render: (props) => (
                                <div className='assessment-wrapper-conatiner'>
                                    <ListComponent
                                        renderType="client"
                                        data={this.state.data || []}
                                        pagination={null}
                                        render={(listItem) => {
                                            return (
                                                <div className="therapy-card" >
                                                    <div>{utils.FormatDate(listItem.appointment_date_time, "DATE_14")}  {listItem?.appointment_date_time ? `, ${utils.FormatDate(listItem.appointment_date_time, "TIME_1")}` : ""}</div>
                                                    <ListComponent
                                                        renderType="client"
                                                        data={listItem.assessment || []}
                                                        pagination={null}
                                                        render={(childListItem) => this.renderAssesment(childListItem)} />
                                                </div>
                                            )
                                        }} />
                                </div>
                            ),
                        },

                        (this.props.data.user_type == "adult" || this.props.data.user_type == "senior_adult" ||(this.props.data.user_type =="adolescent"&& this.state.v1_data.length > 0)) && {
                            value: "chart",
                            label: this.props.data.user_type == "adolescent"?`${CONSTANTS.ASSESSING_FLEXIBILITY} (Adult)`:`${CONSTANTS.ASSESSING_FLEXIBILITY}`,
                            render: (props) => <TherapyIntakeChart data={this.props.data.user_type == "adolescent"?this.state.v1_data:this.state.data} />,
                        },

                       
                        (this.props.data.user_type == "adolescent"  ) && {
                            value: "chart-v2",
                            label: `${CONSTANTS.ASSESSING_FLEXIBILITY} (Adolescent)`,
                            render: (props) => <TherapyIntakeChart data={this.state.v2_data} />,
                        },
                        {
                            value: "feedback",
                            label: CONSTANTS.FEEDBACK,
                            render: (props) => < Feedback data={this.state.data} />,
                        },
                    ]}
                />
            </div>
            )}
            </>
        );
    }
}
